<section class="admin-users">
    <header class="row page-header">
        <div class="col-sm-6">
            <h2 class="title">USERS</h2>
        </div>
        <div class="col-sm-6 text-end margin-top-10">
            <button class="btn btn-link" type="submit" (click)="onExportToExcel()">
                <i class="fa-regular fa-file-excel" aria-hidden="true"></i> Export to Excel
            </button>
        </div>
    </header>

    <main>
        <sp-admin-user-list
            #adminUserList
            [userFilterSettings]="userFilterSettings$ | async" 
            [adminUsers]="adminUsers$ | async"
            (filterChanged)="onFilterChanged($event)">
        </sp-admin-user-list>
    </main>
</section>